import React from "react";
import { FaEdit } from "react-icons/fa";
import EditMailingAddress from "./EditMailingAddress";
import Skeleton from "react-loading-skeleton";

const MailingAddress = ({ userProfile, isLoading, refetch }) => {
  return (
    <>
      <div className="d-flex justify-content-between mb-2">
        <h4 className="small-text font-weight-bold">Mailing Addresses: <span style={{ color: '#8e3039' }}>*</span></h4>
        <button
          className="btn btn-outline-primary btn-edit-user-profile"
          data-toggle="modal"
          data-target="#editMailingAddress"
        >
          <FaEdit size={16} className="mr-2" /> Edit
        </button>
        <EditMailingAddress
          userProfile={userProfile}
          isLoading={isLoading}
          refetch={refetch}
        />
      </div>
      <div className="row small-text">
        {userProfile?.mailingAddresses &&
          userProfile?.mailingAddresses.map((item, key) => (
            <div className="col-md-6" key={key}>
              <div className="row">
                <div className="col-md-12 d-flex mb-1">
                  <p className="text-lowercase text-capitalize">
                    {item?.addressType} Address:{" "}
                  </p>
                  <div className="ml-4">
                    {item?.preferred && (
                      <div className=" badge_pomme bg_primary f-10 text-light rounded-pill d-flex align-items-center justify-content-center">
                        <span>Preferred Mailing Address</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <p className="font-weight-bold">
                    {item?.addressType
                      ? `${item?.streetAddress}, ${item?.city}, ${item.country}, ${item.postalCode}`
                      : isLoading && <Skeleton width={100} height={20} />}
                  </p>
                </div>
              </div>
            </div>
          ))}
      </div>
    </>
  );
};

export default MailingAddress;
